import { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import PageContainer from "../components/pages-parts/PageContainer";
import AboutImage from "../components/pages-parts/AboutImage";
const About = () => {
  const [state] = useState({
    heading: "about us",
    pageHeading:
      "A Household Name in the Construction Industry founded by budded Professionals",
    message:
      "The key element of the company vision is to develop and embrace emerging technologies and processes in dealing with physical challenges in today’s construction industry.",
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>About page</title>
        <meta name="description" content="Global Talia Limited about page" />
      </Helmet>
      <PageContainer data={state}>
        <AboutImage />
      </PageContainer>
    </>
  );
};
export default About;
